import { useRouteError } from 'react-router-dom';
import ContentError      from '@widesk-ui/components/ContentError';

export default function ErrorPage() {
	const error = useRouteError();

	return <ContentError error={error} />;
}
